import { useMutation, useQueryClient } from '@tanstack/react-query'
import axiosInstance from '@/api/axiosInstance'

export const useConfigureProfile = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: any) => {
            const response = await axiosInstance.post('/provider-configuration/configure_profile/', data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profile-status'] })
            queryClient.invalidateQueries({ queryKey: ['provider-profile'] })
        },
    })
}

export const useUpdateOfferingsConfig = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: any) => {
            const response = await axiosInstance.post('/provider-configuration/update_offerings/', data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['service-offerings'] })
            queryClient.invalidateQueries({ queryKey: ['provider-profile'] })
            queryClient.invalidateQueries({ queryKey: ['profile-status'] })
        },
    })
}


